/** Deadline-Spalten der Bestellposition — Abschnitt „Deadlines“ aus `IwmColumnsBestellposition`. */

import type { OrderPosition } from '@/types/entities';

import { DeadlineCell } from '../shared/DeadlineCell';
import type { CellTemplateMap } from '../types';

export const orderPositionDeadlineTemplates: CellTemplateMap<OrderPosition> = {
  ShippingMarksFinal: (model) => (
    <DeadlineCell deadline={model.ShippingMarksDeadline} final={model.ShippingMarksFinal} />
  ),
  IdLabelFinal: (model) => (
    <DeadlineCell deadline={model.IdLabelDeadline} final={model.IdLabelFinal} />
  ),
  ManualFinal: (model) => (
    <DeadlineCell deadline={model.ManualDeadline} final={model.ManualFinal} />
  ),
  PackagingFinal: (model) => (
    <DeadlineCell deadline={model.PackagingDeadline} final={model.PackagingFinal} />
  ),
  PanelFinal: (model) => <DeadlineCell deadline={model.PanelDeadline} final={model.PanelFinal} />,
};

export default orderPositionDeadlineTemplates;
